export const SITE_SUBSCRIBER_DETAILS_CARD_FRENCH_LOCALE = {
  title: "Adhérent",
  subscriberId: "Id adhérent",
  name: "Nom",
  mails: "E-mails",
  phones: "Numéros de téléphone",
  noSubscriber: {
    title: "Aucun adhérent",
    subtitle: "Aucun adhérent n'est relié au site",
  },
  myVoltalis: "Accès MyVoltalis",
  flags: {
    privileged: "PSB",
    vip: "VIP",
  },
};
